import Image from 'next/image'
import { Link } from '@/navigation'

import type { FC } from 'react'
import type { ISpecialistData } from '@/types'

const SpecialistCard: FC<ISpecialistData> = (props) => {
  return (
    <Link
      href={'/team/' + props.slug}
      aria-label={props.full_name + ' ' + props.position}
      className="flex h-full w-full flex-col overflow-hidden rounded-xl bg-white shadow-secondary-light/10 duration-200"
    >
      <div className="h-[271px] w-auto overflow-hidden rounded-t-xl">
        <Image
          src={props.avatar}
          alt={props.full_name}
          width={264}
          height={271}
          className="h-full w-full object-cover"
        />
      </div>
      <div className="flex grow flex-col rounded-b-xl border border-secondary-light bg-white p-5">
        <h3 className="mb-2 text-[18px] font-bold leading-[24px]">{props.full_name}</h3>
        <p className="leading-[24px] text-secondary-dark">{props.position}</p>
      </div>
    </Link>
  )
}

export default SpecialistCard
